export var DeliveryOptions;
(function (DeliveryOptions) {
    DeliveryOptions["dropshipping"] = "home";
    DeliveryOptions["order"] = "store";
    DeliveryOptions["all"] = "all";
})(DeliveryOptions || (DeliveryOptions = {}));
